import React from "react";
import { Link } from "react-router-dom";

const HomeSIngleService = ({ icon, title, descripcion, border_class }) => {
  return (
    <>
      <div className="col-xl-4 col-lg-6 col-md-6">
        <div
          className={
            border_class
              ? `service-box ${border_class} text-center mb-40`
              : "service-box text-center mb-40"
          }
        >
          <div className="service-thumb">
            <i className={icon}></i>
          </div>
          <div className="service-content">
            <h3>
              <Link to="#">{title}</Link>
            </h3>
            <p>{descripcion}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeSIngleService;
